import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeTabs()
    this.initializeNotificationCheckboxes()
    
    const style = document.createElement('style')
    style.textContent = '.subscribed-section.show { display: block !important; }'
    document.head.appendChild(style)
  }

  initializeTabs() {
    const tabButtons = this.element.querySelectorAll('button[data-tab-id]')
    
    tabButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        this.switchTab(button.dataset.tabId)
      })
    })
  }

  initializeNotificationCheckboxes() {
    const selectAllCheckbox = this.element.querySelector('#select_all_subscription_notifications')
    const notificationCheckboxes = this.element.querySelectorAll('.notification-checkbox:not(.select-all)')

    if (selectAllCheckbox && notificationCheckboxes.length > 0) {
      const updateAllCheckboxes = (checked) => {
        notificationCheckboxes.forEach(checkbox => {
          checkbox.checked = checked
        })
      }

      selectAllCheckbox.addEventListener('change', function() {
        updateAllCheckboxes(this.checked)
      })

      notificationCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
          const allChecked = Array.from(notificationCheckboxes).every(cb => cb.checked)
          selectAllCheckbox.checked = allChecked
        })
      })

      selectAllCheckbox.checked = Array.from(notificationCheckboxes).every(cb => cb.checked)
    }
  }

  switchTab(tabId) {
    const tabButtons = this.element.querySelectorAll('button[data-tab-id]')
    tabButtons.forEach(button => {
      const isActive = button.dataset.tabId === tabId
      button.classList.toggle('border-primary', isActive)
      button.classList.toggle('text-primary', isActive)
      button.classList.toggle('border-transparent', !isActive)
      button.classList.toggle('text-neutral-500', !isActive)
      button.setAttribute('aria-selected', isActive ? 'true' : 'false')
    })

    const tabPanels = this.element.querySelectorAll('.tab-panel')
    tabPanels.forEach(panel => {
      const isActive = panel.dataset.tabId === tabId
      panel.classList.toggle('hidden', !isActive)
    })
  }
}
